import rights from './rights'

export default {
    fundingProgramId: 'Förderprogramm {id}',

    number: 'Nummer',
    name: 'Name',
    shortName: 'Kurzname',
    description: 'Beschreibung',
    parentFundingProgram: 'Übergeordnetes Förderprogramm',
    noParentFundingProgram: 'Kein übergeordnetes Förderprogramm',
    isActive: 'Aktiv',
    requiresTransferAgreement: 'Pro Organisation und Jahr muss ein Weiterleitungsvertrag in diesem Bereich angelegt werden',
    requiresGoalAgreement: 'Pro Organisation und Jahr muss eine Zielvereinbarung in diesem Bereich angelegt werden',
    requiresGoalAchievement: 'Pro Organisation und Jahr muss eine Auswertung in diesem Bereich angelegt werden',
    requiresAuditNote: 'Pro Organisation und Jahr muss ein Prüfvermerk in diesem Bereich angelegt werden',
    requiresFinalApproval: 'Pro Organisation und Jahr muss eine Endbewilligung in diesem Bereich angelegt werden',
    transferAgreementSumGroup: 'Summe im Weiterleitungsvertrag',
    transferAgreementSumGroupHint: 'Legt fest, in welche Summe die Maßnahmen dieses Programms einfließen. Gilt nur, wenn im übergeordneten Bereich pro Organisation und Jahr ein Weiterleitungsvertrag angelegt wird.',
    transferAgreementSumGroups: {
        personnel_costs: 'Personalkosten (Nr. VI 1 KJP)',
        fixed_amount_activities: 'Aktivitäten mit Festbetragsfinanzierung (Nr. VI 2.1 KJP)',
        deficit_activities: 'Aktivitäten mit Fehlbedarfsfinanzierung (Nr. VI 2.3 - 2.5 KJP)',
    },
    requiresProcessProtectionConcept: 'Erfordert Schutzkonzept für Maßnahmen',
    requiresOrganisationProtectionConcept: 'Erfordert Schutzkonzept für Organisationen',

    selectParentFundingProgramWarning: 'Warnung: Wenn Sie ein übergeordnetes Förderprogramm auswählen, werden alle diesem Programm zugeordneten Programme losgelöst und Verknüpfungen aufgehoben. Dies kann nicht rückgängig gemacht werden. Anzahl der untergeordneten Programme: {count}',

    forms: 'Formulare',

    slideOver: {
        description: 'Wählen Sie ein Formular aus, um eine neue Maßnahme zu erstellen.',
        search: 'Suche',
        searchPlaceholder: 'Suche nach Förderprogrammen'
    },

    savedSuccessfully: 'Förderprogramm wurde erfolgreich gespeichert.',
    saveError: 'Das Förderprogramm konnte nicht gespeichert werden.',
    deleteFundingProgram: 'Förderprogramm löschen',
    deleteFundingProgramText: 'Möchten Sie dieses Förderprogramm wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteFundingProgramSuccess: 'Förderprogramm wurde erfolgreich gelöscht.',
    deleteFundingProgramError: 'Das Förderprogramm konnte nicht gelöscht werden.',

    reportsExplanation: 'Hier kann festgelegt werden, welche Auswertungen für das Förderprogramm verfügbar sind.',

    table: {
        title: 'Förderprogramme',
        name: 'Name',
        parentFundingProgram: 'Übergeordnetes Förderprogramm',
        parent_funding_program_name: 'Übergeordnet',
        short_name: 'Kurzname',
        description: 'Beschreibung',
        is_active: 'Aktiv',
        created_at: 'Erstellt am'
    },

    menu: {
        fundingProgramBaseData: 'Daten',
        fundingProgramRights: 'Rechte',
        fundingProgramReports: 'Auswertungen'
    },

    rights
}